var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GridView',{attrs:{"isExpanded":_vm.isExpanded,"elements":_vm.allElements,"groups":_vm.normalizedGroups,"onSelect":_vm.onSelect,"onExpand":_vm.onExpand,"selectedElement":_vm.$store.state.uiState.activeAddon,"onCollapse":_vm.onCollapse}})}
var staticRenderFns = []

export { render, staticRenderFns }